import { FluentBundle, FluentResource } from '@fluent/bundle'
import { createFluentVue } from 'fluent-vue'
import englishTranslations from './en.ftl?raw'
import norwegianTranslations from './nb_NO.ftl?raw'
import swedishTranslations from './sv.ftl?raw'

const translations = {
  en: englishTranslations,
  no: norwegianTranslations,
  se: swedishTranslations,
}
export const initFluent = (locale) => {
  const defaultLocale = 'en'
  const chosenLocale = locale || defaultLocale
  const translationBundle = new FluentBundle(chosenLocale)
  translationBundle.addResource(new FluentResource(translations[chosenLocale]))
  return createFluentVue({
    bundles: [translationBundle],
  })
}
